<script>
import Basket from "./basket.svelte"
import Billing from './billing.svelte'
import Delivery from './delivery.svelte'
import {postage,basket} from "./basket-store.js"
import {save} from "../shared/api"
import Formrow from "../shared/formrow.svelte"
import { tick, beforeUpdate } from 'svelte';
import {session} from "../account/account-store.js"
import LoginModal from "../account/login-modal.svelte"
export let forcelogin = false
// Riot checkout has below props
// <checkout showoffers="{true}" currency="USD" invoice="{true}" ponumber="{true}" showorg="{true}" forcelogin="{false}" reload="{true}"></checkout>
// Think the above could be good to get from settings if possible ?
let step = 0;
let billing = {};
let delivery = {}
let useBilling = false
let postageAndPacking = null
let transaction = {}
let submitter = null
let stripeLoaded = false
let paymentTransaction = null
let paymentform = null
let loginOpen = null
postage.load()
session.load()

beforeUpdate(function(){
  if($session.id && step==0){
    step = 1
    billing = $session
  }
})

const confirm = ()=>{
  if(useBilling) delivery = billing
  step=2 
}

const setPostage = (e)=>{
  postageAndPacking = e.target.value
  basket.postage({
    country_code:delivery.country,
    postage_id:postageAndPacking,
    currency:$basket.currency
  })
}

const submitTo = (cback)=>{
  submitter = cback
}

const invoice = async ()=>{
  transaction = {
    invoice:true,
    billing:billing ,
    delivery:delivery,
    postage:postageAndPacking
  }
  try {
    transaction = (await save({url:"/duocms/api/transactions",data:transaction})).data
    if(transaction.id){ //redirect so analytics can be captured for invoice if a transaction id is returned
      window.location.href = "/duocms/api/transactions/success/"+transaction.id 
    }
    step = 5 
  }catch(err){
    step = 4
  }
}

const loadStripe = async ()=>{
  if(stripeLoaded) return 
  stripeLoaded = true // prevent running twice
  return new Promise((resolve,reject)=>{
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.addEventListener("load",()=>{ 
      console.log("loaded")
      setTimeout(resolve,2000)
    })
    script.src = 'https://js.stripe.com/v3/'
    document.getElementsByTagName('head')[0].appendChild(script)
  })
}

const paybycard = async ()=>{
  transaction = {
    billing:billing ,
    delivery:delivery,
    postage:postageAndPacking
  }
  try {
    transaction = (await save({url:"/duocms/api/transactions",data:transaction})).data
    if(transaction.session){ //stripe
      await loadStripe()
      stripeProcess(transaction)
    }else{
      paymentTransaction = transaction
      await tick()
      if(paymentform){
        paymentform.submit()
      }
    }
    step = 3
  }catch(err){
    // show toaster error here?
  }
}

const stripeProcess = async (transaction)=>{
  let stripe = window.Stripe(transaction.pubkey)
  result = await stripe.redirectToCheckout({sessionId:transaction.session.id})
  // transactionErrorMessage = result.error.message // trigger toaster error here?
}

const complete = (e)=>{
  e.preventDefault()
  submitter()
}

</script>
<br>
  {#if $basket.items && $basket.items.length}
  <div class="btn-group btn-group-justified">
    <button on:click={(e)=> step=0} class="btn {step==0 ? 'btn-primary' : 'btn-default'}">Basket</button>
    <button on:click={(e)=> step=1} class="btn {step==1 ? 'btn-primary' : 'btn-default disabled'}">Choose Address</button>
    <button on:click={(e)=> step=2} class="btn {step==2 ? 'btn-primary' : 'btn-default disabled'}">Confirm Details</button>
    <button on:click={(e)=> step=3} class="btn {step==3 ? 'btn-primary' : 'btn-default disabled'}">Enter Payment Details</button>
    <button on:click={(e)=> step=4} class="btn {step==4 ? 'btn-primary' : 'btn-default disabled'}">Order Confirmed</button>
  </div>
  <br>
  <Basket readonly={step>1} currency={$basket.currency} />

  {#if step==0}
    <p>Please choose from the options below</p>
    <div class="btn-toolbar">
      <button class="btn btn-default" on:click={(e)=> loginOpen=true}>Sign In</button>
      {#if forcelogin}
        <a class="btn btn-primary" href="/system/signup/">Sign Up</a>
      {:else}
        <button class="btn btn-primary" on:click={(e)=> step=1 }>Continue to Guest Checkout</button>
      {/if}
    </div>
  {/if}

  {#if step==1}
    <form on:submit={confirm}>
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <h3>Billing Details</h3>
          <Billing bind:user={billing} />
        </div>
        <div class="col-xs-12 col-sm-6">
          <h3>Delivery Details</h3>
          <label class="sameas"><input type="checkbox" bind:checked={useBilling} /> Same as Billing</label>
          {#if useBilling}
            <Delivery bind:user={billing} />
          {:else}
            <Delivery bind:user={delivery} />
          {/if}
        </div>
      </div>
      <div class="btn-toolbar">
        {#if !billing.id}
          <button class="btn btn-default"on:click={(e)=> step=0 }>Go Back</button>
          <button class="btn btn-default">Sign In</button>
        {/if}
        <button class="btn btn-primary" type="submit">Proceed</button>
      </div>
    </form>
  {/if}

  {#if step==2}
    <form on:submit={complete}>
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <h3>Billing Details</h3>
          <Billing user={billing} fixed={true} />
        </div>
        <div class="col-xs-12 col-sm-6">
          <h3>Delivery Details</h3>
          <Delivery user={delivery} fixed={true} />
          <!-- POSTAGE OPTIONS HERE -->
          <Formrow label="Postage" type="select" name="postage" required on:change={setPostage}>
            <option value="">Please Select</option>
            {#each $postage as post}
              <option value={post.id} selected={post.id==postageAndPacking}>{post.name}</option>
            {/each}
          </Formrow>
        </div>
      </div>
      <div class="btn-toolbar">
        <button class="btn btn-default"on:click={(e)=> step = 1 }>Go Back</button>
        <button class="btn btn-default" on:click={(e)=> submitTo(paybycard)}>Pay By Card</button>
        <button class="btn btn-primary" on:click={(e)=> submitTo(invoice)}>Invoice Me</button>
      </div>
    </form>
  {/if}

  {#if step==3}
    <p>Processing...</p>
  {/if}

  {#if paymentTransaction}
    <form action="{paymentTransaction.url}" method="POST" name="paymentform" bind:this={paymentform}>
      {#each Object.keys(paymentTransaction.data) as key}
        <input type="hidden" name={key} value={paymentTransaction.data[key]} />
      {/each}
    </form>
  {/if}

  <LoginModal open={loginOpen} />
{:else if $basket.items}
  <p>Your basket is empty</p>
{/if}
<br>
<style>
  .sameas input{
    margin-left:165px;
  }
  .btn-group-justified{
    display:flex;
  }
  .btn-group-justified .btn{
    flex:1;
  }

</style>